import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL, NAV_LINKS } from "@/data/content";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-black/90 backdrop-blur-2xl border-b border-white/10" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
            <img src={LOGO_URL} alt="Louisiana Ducks logo" className="h-14 w-14 object-contain drop-shadow-[0_0_12px_rgba(254,225,35,0.25)]" data-testid="nav-logo" />
            <div className="leading-none">
              <span className="font-display text-2xl sm:text-3xl uppercase text-white tracking-wide block">Louisiana Ducks</span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-7" data-testid="nav-links-desktop">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `gold-underline text-sm font-bold uppercase tracking-widest transition-colors duration-200 ${
                    isActive ? "text-[#FEE123]" : "text-gray-300 hover:text-white"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/donate"
              data-testid="nav-donate-button"
              className="bg-[#FEE123] text-black text-sm font-extrabold uppercase tracking-widest px-6 py-3 rounded-sm transition-transform duration-200 hover:scale-105 hover:bg-[#FFEA61]"
            >
              Donate
            </Link>
          </nav>

          <button
            className="md:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden bg-[#0A0A0A] border-t border-white/10 px-4 py-6 space-y-4" data-testid="nav-links-mobile">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${link.label.toLowerCase()}`}
              className={({ isActive }) =>
                `block text-base font-bold uppercase tracking-widest ${isActive ? "text-[#FEE123]" : "text-gray-300"}`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link
            to="/donate"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-donate-button"
            className="block text-center bg-[#FEE123] text-black text-base font-extrabold uppercase tracking-widest px-6 py-3 rounded-sm"
          >
            Donate
          </Link>
        </nav>
      )}
    </header>
  );
}
